import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-20 md:py-28 bg-background-200/50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="inline-block px-3 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-6">
              About Hipobuy Sheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
              Everything You Need To Know About Hipobuy Spreadsheet
            </h2>
            <p className="text-foreground-600 leading-relaxed text-base">
              <strong>Hipobuy Spreadsheet</strong> is an organized research resource designed to transform how shoppers discover and evaluate products. Unlike traditional browsing methods that involve endless scrolling through random listings, the spreadsheet approach brings structure, clarity, and efficiency to your shopping workflow.
            </p>
            <p className="text-foreground-600 leading-relaxed text-base mt-4">
              Whether you are hunting for the latest sneakers, comparing jacket options across multiple sellers, or simply wanting to browse curated product collections, the spreadsheet format gives you the power to filter, sort, and compare with precision. Our independent guides and{' '}
              <Link to="/hipobuy-spreadsheet-guide" className="text-primary-600 underline underline-offset-2 hover:text-primary-700 transition-colors cursor-pointer">
                comprehensive resources
              </Link>{' '}
              help both beginners and experienced shoppers make smarter decisions.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-background-50 rounded-2xl p-6 md:p-8">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider w-[45%]">Traditional Searching</th>
                    <th className="text-left py-3 px-3 text-xs font-semibold text-primary-600 uppercase tracking-wider w-[10%]"></th>
                    <th className="text-left py-3 px-3 text-xs font-semibold text-foreground-500 uppercase tracking-wider w-[45%]">Hipobuy Spreadsheet</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { left: 'Random browsing', right: 'Organized database' },
                    { left: 'Slow research', right: 'Faster discovery' },
                    { left: 'Hard comparison', right: 'Structured comparison' },
                    { left: 'Limited overview', right: 'Category-based research' },
                    { left: 'Scattered information', right: 'Centralized resources' },
                  ].map((row, i) => (
                    <tr key={i} className="border-b border-background-100">
                      <td className="py-3 px-3 text-sm text-foreground-600">{row.left}</td>
                      <td className="py-3 px-3 text-center">
                        <i className="ri-arrow-right-line text-primary-500"></i>
                      </td>
                      <td className="py-3 px-3 text-sm text-foreground-900 font-medium">{row.right}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
              {[
                { value: '14', label: 'Categories' },
                { value: '20K+', label: 'QC Entries' },
                { value: '98%', label: 'Data Accuracy' },
                { value: '10K+', label: 'Active Users' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}